<template>
  <div v-if="getActiveVariationFilters.length > 0 || getActiveAttributeFilters.length > 0" class="listing-filters-clear-all">
    <a
      class="listing-filters-clear-all-link"
      :href="getUrlNoFilters"
    >
      {{ t('variation.listing.clear.all') }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdvClearListingFilters',
  props: [],
  computed: {
    ...mapGetters([
      'getActiveVariationFilters',
      'getActiveAttributeFilters',
      'getUriWithoutOffset',
      'getIsTopLevelCategory',
      'getUrlNoFilters',
      'config'
    ])
  }
}
</script>

<style lang="scss" scoped>
.listing-filters {
  &-clear-all {
    width: 100%;
    position: relative;
    display: grid;
    align-items: center;
    justify-items: center;
    text-align: center;
    &-link {
      width: 100%;
      padding: 5px;
      background: #ffebeb;
      border-radius: 5px;
    }
  }
}
</style>
